export default {
  props: {
    /**
     * Background theme: light | dark
     */
    theme: {
      type: String,
      default: 'light',
      validator: val => ['light', 'dark'].includes(val)
    }
  },
  computed: {
    cssClasses () {
      return {
        'bc-light-grey': this.theme === 'dark',
        'bc-light-white': this.theme === 'white'
      }
    }
  }
}
